var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "#303245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.66914C7.24 2.66914 5.8 4.10914 5.8 5.86914C5.8 7.62914 7.24 9.06914 9 9.06914C10.76 9.06914 12.2 7.62914 12.2 5.86914C12.2 4.10914 10.76 2.66914 9 2.66914ZM9 8.26914C7.68 8.26914 6.6 7.18914 6.6 5.86914C6.6 4.54914 7.68 3.46914 9 3.46914C10.32 3.46914 11.4 4.54914 11.4 5.86914C11.4 7.18914 10.32 8.26914 9 8.26914ZM17.88 5.58914L16.16 3.84914C14.26 1.92914 11.72 0.869141 9 0.869141C6.28 0.869141 3.74 1.92914 1.84 3.84914L0.12 5.58914C-0.04 5.74914 -0.04 5.98914 0.12 6.14914L1.84 7.88914C3.74 9.80914 6.28 10.8691 9 10.8691C11.72 10.8691 14.26 9.80914 16.16 7.88914L17.88 6.14914C18.04 5.98914 18.04 5.74914 17.88 5.58914ZM15.6 7.32914C13.84 9.08914 11.5 10.0691 9 10.0691C6.5 10.0691 4.16 9.08914 2.4 7.32914L0.96 5.86914L2.4 4.40914C4.16 2.64914 6.5 1.66914 9 1.66914C11.5 1.66914 13.84 2.64914 15.6 4.40914L17.04 5.86914L15.6 7.32914Z",
    fill: "#303245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.058d41aeabd1a458656fd98bb3821e39.svg";
export { ForwardRef as ReactComponent };